export const Blogs = [
    {
        id:22,
        name:"A Dança do Design: Desvendando a Lei de Conway",
        tags:["lei de conway, conway"],
        date:"4 de dezembro de 2023",
        imgSrc:"https://miro.medium.com/v2/resize:fit:640/format:webp/1*zVkimtbOQZooq5et9eibuQ.png",
        link:"https://www.linkedin.com/pulse/dan%25C3%25A7a-do-design-desvendando-lei-de-conway-bruno-l9nvf/?trackingId=JXAjv4djRfyucLouo%2Fsl8A%3D%3D"
    },
    {
        id:21,
        name:"On-Premise, Cloud e o Híbrido oque é ? qual e quando usar?",
        tags:["onprimise, cloud, hibrid, hibrido"],
        date:"28 de novembro de 2023",
        imgSrc:"https://miro.medium.com/v2/resize:fit:720/format:webp/1*b4AQvZsU7A40Q5QZ9NU5Sg.png",
        link:"https://www.linkedin.com/pulse/on-premise-cloud-e-o-h%25C3%25ADbrido-oque-%25C3%25A9-qual-quando-usar-bruno-fxcef/?trackingId=JXAjv4djRfyucLouo%2Fsl8A%3D%3D"
    },
    {
        id:20,
        name:"Depuração Eficiente no Visual Studio: Desvendando os Segredos do Debugging",
        tags:["bug, depuracao, visual studio, debugar, debugando"],
        date:"20 de novembro de 2023",
        imgSrc:"https://miro.medium.com/v2/resize:fit:720/format:webp/1*SQ9XeihV-MAfXxBY7AAuSg.jpeg",
        link:"https://www.linkedin.com/pulse/depura%25C3%25A7%25C3%25A3o-eficiente-visual-studio-desvendando-os-do-bruno-xjcrf/?trackingId=JXAjv4djRfyucLouo%2Fsl8A%3D%3D"
    },
    {
        id:19,
        name:"Desvendando o BFF - Backend para Frontend: Uma Abordagem Estratégica na Arquitetura de Software Moderna",
        tags:["bff, pattern, designpattern, backend for frontend"],
        date:"13 de novembro de 2023",
        imgSrc:"https://miro.medium.com/v2/resize:fit:720/format:webp/1*DjYwISvJBvoKSVXcMmfJXQ.png",
        link:"https://www.linkedin.com/pulse/desvendando-o-bff-backend-para-frontend-uma-na-de-bruno-oehef/?trackingId=JXAjv4djRfyucLouo%2Fsl8A%3D%3D"
    },
    {
        id:18,
        name:"A magia do reconhecimento profissional indo além dos números",
        tags:["reconhecimento, empresa, satisfacao, reconhecer"],
        date:"12 de outubro de 2023",
        imgSrc:"https://media.licdn.com/dms/image/v2/D4D12AQEtsSaGAFDZGA/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1697119061598?e=1730937600&v=beta&t=eaRktmTgxyUIPuYfQEliOY5V2tHMh2bWX9qFMgWY_b0",
        link:"https://www.linkedin.com/pulse/magia-do-reconhecimento-profissional-indo-al%25C3%25A9m-dos-bruno-7ud9f/?trackingId=JXAjv4djRfyucLouo%2Fsl8A%3D%3D"
    },
    {
        id:17,
        name:"Aproveitando todo o potencial do TypeScript: Utilizando Interfaces para Definir Tipos de Dados em Projetos ReactJS",
        tags:["typescript, react, frontend, javascript"],
        date:"24 de julho de 2023",
        imgSrc:"https://media.licdn.com/dms/image/v2/D4D12AQHnB5O-UP0Zcg/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1689515701776?e=1730937600&v=beta&t=nIpW1Nbw_rkF-Yg5FeOnU5jrETnxYs_uC9FkV4AMD64",
        link:"https://www.linkedin.com/pulse/aproveitando-todo-o-potencial-do-typescript-para-de-bruno/?trackingId=JXAjv4djRfyucLouo%2Fsl8A%3D%3D"
    },
    {
        id:16,
        name:"A Importância dos Testes Unitários: Garantindo a Qualidade e a Confiabilidade de seus Projetos",
        tags:["unitTest, test, security, tdd"],
        date:"24 de julho de 2023",
        imgSrc:"https://media.licdn.com/dms/image/v2/D4D12AQHB80isaHqr_Q/article-cover_image-shrink_423_752/article-cover_image-shrink_423_752/0/1689512579786?e=1730937600&v=beta&t=zbG7I1uwU-wXQcF3B9QNfinmjzDS5EovUTdZa7w0drw",
        link:"https://www.linkedin.com/pulse/import%25C3%25A2ncia-dos-testes-unit%25C3%25A1rios-garantindo-qualidade-bruno/?trackingId=JXAjv4djRfyucLouo%2Fsl8A%3D%3D"
    },
    {
        id:15,
        name:"A sua vida financeira está segura? Segurança Digital",
        tags:["seguranca, segurancadigital, security"],
        date:"17 de julho de 2023",
        imgSrc:"https://media.licdn.com/dms/image/v2/D4D12AQE-YEqgzfT6Bg/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1683775333743?e=1730937600&v=beta&t=b7syYUxX1H2b6TyFzMbegrGQJwDyOl3wHkGRkAoJuaI",
        link:"https://www.linkedin.com/pulse/sua-vida-financeira-est%25C3%25A1-segura-seguran%25C3%25A7a-digital-bruno/?trackingId=JXAjv4djRfyucLouo%2Fsl8A%3D%3D"
    },
    {
        id:14,
        name:"Como usar a IA para aumentar sua produtividade",
        tags:["ia, produtividade"],
        date:"10 de julho de 2023",
        imgSrc:"https://media.licdn.com/dms/image/v2/D4D12AQHpASRyH6vbHw/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1683774508733?e=1730937600&v=beta&t=YRuYpvb-1f_4TLy-lPQi3ZW-bTsCtjj1Se5WwpqPyHk",
        link:"https://www.linkedin.com/pulse/como-usar-ia-para-aumentar-sua-produtividade-bruno/?trackingId=JXAjv4djRfyucLouo%2Fsl8A%3D%3D"
    },
    {
        id:13,
        name:"Como criar uma aplicação React com Vite",
        tags:["vite, frontend, creeate vite, react"],
        date:"3 de julho de 2023",
        imgSrc:"https://media.licdn.com/dms/image/v2/D4D12AQHEwDtQ_nxMIg/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1683772754114?e=1730937600&v=beta&t=i39u66bM2VfXzieOVwZX-pOME5i4C1pIAkADJUIEfXY",
        link:"https://www.linkedin.com/pulse/como-criar-uma-aplica%25C3%25A7%25C3%25A3o-react-com-vite-henrique-moreira-carvalho/?trackingId=JXAjv4djRfyucLouo%2Fsl8A%3D%3D"
    },
    {
        id:12,
        name:"Clean code no ASPET Core",
        tags:["cleancode, aspnet core, coding, developer, aspnetcore"],
        date:"26 de junho de 2023",
        imgSrc:"https://media.licdn.com/dms/image/v2/D4D12AQEInjryXWZGKg/article-cover_image-shrink_423_752/article-cover_image-shrink_423_752/0/1683773613211?e=1730937600&v=beta&t=dLssOYTG7wtJvdC5kiaaXSwI3OD9CeXXsLJpxYkvTe4",
        link:"https://www.linkedin.com/pulse/clean-code-aspet-core-bruno-henrique-moreira-carvalho/?trackingId=%2B%2BorPDt0Temq3oPbjer%2Bdw%3D%3D"
    },
    {
        id:11,
        name:"Como criar ação ReactJs com create-react-app",
        tags:["create-react-app, ReactJs, ferramentaweb"],
        date:"19 de junho de 2023",
        imgSrc:"https://media.licdn.com/dms/image/v2/D4D12AQG8jlbSFKwvnA/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1683771998104?e=1730937600&v=beta&t=EC2Jlyf71IjDKPDgpA2bqJQkbmp166EYiBbowopLdig",
        link:"https://www.linkedin.com/pulse/como-criar-a%25C3%25A7%25C3%25A3o-reactjs-com-create-react-app-bruno/?trackingId=%2B%2BorPDt0Temq3oPbjer%2Bdw%3D%3D"
    },
    {
        id:10,
        name:"Gerenciamento de Estado com React Hooks",
        tags:["ReactJs, Hooks, react-hooks, WebDeveloper, state"],
        date:"12 de junho de 2023",
        imgSrc:"https://media.licdn.com/dms/image/v2/D4D12AQFqMCJ1bo1cjg/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1683771307292?e=1730937600&v=beta&t=gxe380eWAIsNFLl7gNdKjVGiTRU07H3_Ifltprpq0ng",
        link:"https://www.linkedin.com/pulse/gerenciamento-de-estado-com-react-hooks-henrique-moreira-carvalho/?trackingId=%2B%2BorPDt0Temq3oPbjer%2Bdw%3D%3D"
    },
    {
        id:10,
        name:"Class Components",
        tags:["ReactJs, ClassComponents, DesenvolvimentoWeb, WebDeveloper, Components"],
        date:"5 de junho de 2023",
        imgSrc:"https://media.licdn.com/dms/image/v2/D4D12AQFxWUAK7MNslw/article-cover_image-shrink_423_752/article-cover_image-shrink_423_752/0/1683736083050?e=1730937600&v=beta&t=Ae10qe2HcR8BeXhtX3Uo4QqWEulET-itq0sAXMhLyQ8",
        link:"https://www.linkedin.com/pulse/componentes-de-classe-em-reactjs-bruno-henrique-moreira-carvalho/?trackingId=%2B%2BorPDt0Temq3oPbjer%2Bdw%3D%3D"
    },
    {
        id:9,
        name:"ASP.NET Core 6",
        tags:["ASPNETCore6, dotnet6, desenvolvimentoweb, seguranca, autenticacao, OAuth2, tecnologia, inovacao, mercado"],
        date:"29 de maio de 2023",
        imgSrc:"https://dkrn4sk0rn31v.cloudfront.net/uploads/2017/07/aplicacoes-self-contained-com-o-net-core.png",
        link:"https://www.linkedin.com/pulse/aspnet-core-6-bruno-henrique-moreira-carvalho/?trackingId=QFFoA38oSHWzC9J5290Jxw%3D%3D"
    },
    {
        id:8,
        name:"Componentes Funcionais react",
        tags:["FunctionComponentes","React","Components"],
        date:"22 de maio de 2023",
        imgSrc:"https://media.licdn.com/dms/image/D4D12AQGUVePzQTH07g/article-cover_image-shrink_720_1280/0/1683738294526?e=1707955200&v=beta&t=1GT4qUXN0Upw-uI1NITP5paoQhwo0cKxsxA_uayKUhk",
        link:"https://www.linkedin.com/pulse/componentes-funcionais-react-bruno-henrique-moreira-carvalho/?trackingId=QFFoA38oSHWzC9J5290Jxw%3D%3D"
    },
    {
        id:7,
        name:"FluentValidation Asp.Net Core",
        tags:["FluentValidation","Asp.Net","ASPNETCore","Validacao","ValidaçãoDeCampos","#BibliotecasNET"],
        date:"15 de maio de 2023",
        imgSrc:"https://dkrn4sk0rn31v.cloudfront.net/uploads/2017/07/aplicacoes-self-contained-com-o-net-core.png",
        link:"https://www.linkedin.com/pulse/fluentvalidation-aspnet-core-bruno-henrique-moreira-carvalho%3FtrackingId=EvBC1igGR%252FWXjjfmwVoPnw%253D%253D/?trackingId=EvBC1igGR%2FWXjjfmwVoPnw%3D%3D"
    },
    {
        id:6,
        name:"Scrum em 2023, ágil? Vale a pena?",
        tags:["scrum","agil","frameworkscrum","scrum2023","framework","scrum guid"],
        date:"7 de maio de 2023",
        imgSrc:"https://media.licdn.com/dms/image/v2/D4D12AQHEST8Vo6R8jw/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1683428806344?e=1730937600&v=beta&t=JCwFlvDryGUasA1EzZ0-n83osoZDRleJmsqJHsUSGqo",
        link:"https://www.linkedin.com/pulse/scrum-em-2023-%2525C3%2525A1gil-vale-pena-bruno-henrique-moreira-carvalho%3FtrackingId=hnO4evK5SZydCqzk0GA6Ww%253D%253D/?trackingId=hnO4evK5SZydCqzk0GA6Ww%3D%3D"
    },
    {
        id:5,
        name:"O que é ReactJS e por que é tão popular ? E ainda vale a pena utilizar em 2023 ?",
        tags:["react","reactjs","reactnative","reactjs2023","webdevelopment","webdev"],
        date:"1 de maio de 2023",
        imgSrc:"https://media.licdn.com/dms/image/D4D12AQHGgFtOjDoSvg/article-cover_image-shrink_720_1280/0/1682381454558?e=1707955200&v=beta&t=Or9D-4vC5_2gCeLlVc1yM8TtnmPchs_doElTdRohuK4",
        link:"https://www.linkedin.com/pulse/o-que-%25C3%25A9-reactjs-e-por-t%25C3%25A3o-popular-ainda-vale-pena-em-bruno/?published=t"
    },
    {
        id:1,
        name:"Ciclo de vida de um componente React com o Effect Hook",
        tags:["react","ciclodevida"],
        date:"24 de abril de 2023",
        imgSrc:"https://media.licdn.com/dms/image/D4D12AQHGgFtOjDoSvg/article-cover_image-shrink_423_752/0/1682381454558?e=1697673600&v=beta&t=skjieD9sc_VKL3G5tG_bEXcHRvZ1y7vK8BsVBgPf4w4",
        link:"https://www.linkedin.com/pulse/ciclo-de-vida-um-componente-react-com-o-effect-hook-bruno/?trackingId=JY6gOMZYT2OAHWLcDPcw4w%3D%3D"
    },
    {
        id:2,
        name:"Fundamentos básicos de JavaScript necessários para aprender React",
        tags:["react","fundamentosparareact","fundamentos"],
        date:"01 de abril de 2019",
        imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--50wZvNu6--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/1wwdyw5de8avrdkgtz5n.png",
        link:"https://www.devmedia.com.br/fundamentos-basicos-de-javascript-necessarios-para-aprender-react/43553"
    },
    {
        id:3,
        name:"Injeção de dependências no .NET Core 2.2",
        tags:["net","netcore","dependencias"],
        date:"01 de abril de 2019",
        imgSrc:"https://static.gunnarpeipman.com/wp-content/uploads/2019/12/dotnet-core-featured.png.webp",
        link:"https://www.devmedia.com.br/injecao-de-dependencias-no-net-core-2-2/40562"
    },
    {
        id:4,
        name:"Aplicações self-contained com o .NET Core",
        tags:["net","netcore","aplicacoesselfcontained"],
        date:"01 de abril de 2022",
        imgSrc:"https://dkrn4sk0rn31v.cloudfront.net/uploads/2017/07/aplicacoes-self-contained-com-o-net-core.png",
        link:"https://www.treinaweb.com.br/blog/aplicacoes-self-contained-com-o-net-core"
    },
] 